import React from "react";
import "./blog-card.scss";
import avatar from "../../assets/cover1.jpg";

export default function BlogCard() {
  return (
    <div className="blog-card card m-3 md-auto">
      <div className="card-body p-0">
        <div>
          <img className="card-image" src={avatar} alt="avatar" />
        </div>
        <div className="pl-2">
          <div className="py-2">20-Jun-2020</div>
          <div className="card-title">
            This is test title. It is long title but not very long
          </div>
          <div className="">
            has been the industry&apos;s standard dummy text ever since the
            1500s, when an unknown printer took a galley of type and scrambled
            it to make a type specimen book...
          </div>
        </div>
        <div className="card-action text-center py-3">
          <button className="btn-view-my-work btn-read-more" >Read more</button>
        </div>
      </div>
    </div>
  );
}

// onClick={() => { history.push('/blogs/1') }}